import React from 'react';
import { Timer } from './Timer';
const Header = ({ name, type, duration }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "header-logo" },
            React.createElement("div", { className: "header-logo-g" }, "G"),
            "\u00A0",
            React.createElement("div", { className: "header-logo-k" }, "K"),
            React.createElement("div", { className: "header-logo-gyaan" }, "GYAAN"),
            ' ',
            React.createElement("div", { className: "header-logo-kreeda" }, "KREEDA")),
        React.createElement("div", { className: "header-name" },
            React.createElement("h2", null, name),
            React.createElement("h4", null,
                "(",
                type,
                ")")),
        React.createElement("div", { className: "header-timer" }, duration && React.createElement(Timer, { duration: Number(duration) || 0 }))));
};
export { Header };
